import React from "react";
import { GoogleLogo } from "@phosphor-icons/react";

export default function AdminLogin() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-screen bg-[hsl(var(--sk-bg))] flex items-center justify-center px-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-10">
          <div className="w-14 h-14 rounded-full bg-[hsl(var(--sk-primary))] mx-auto flex items-center justify-center text-white font-display text-2xl">S</div>
          <h1 className="mt-6 font-display text-4xl tracking-tighter">SUNKOP Admin</h1>
          <p className="mt-3 text-sm text-[hsl(var(--sk-muted-fg))]">Restricted to authorised staff only</p>
        </div>
        <button onClick={login} data-testid="admin-google-login"
          className="w-full flex items-center justify-center gap-3 bg-white border border-[hsl(var(--sk-border))] rounded-full py-4 hover:bg-[hsl(var(--sk-muted))] transition-colors">
          <GoogleLogo size={20} weight="bold" />
          <span className="text-sm font-medium">Sign in with Google</span>
        </button>
      </div>
    </div>
  );
}
